import { render, staticRenderFns } from "./perform_check_question.vue?vue&type=template&id=6b4ac5ab"
import script from "./perform_check_question.vue?vue&type=script&lang=js"
export * from "./perform_check_question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports